import {type MutableRefObject, useCallback} from "react";

import {useGlobalEvent} from "~/contexts/event/GlobalEventBusContext";

export const useKeyboardHandlers = (
  multiSelection: MutableRefObject<boolean>,
) => {
  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Shift") {
        multiSelection.current = true;
      }
    },
    [multiSelection],
  );

  const handleKeyUp = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Shift") {
        multiSelection.current = false;
      }
    },
    [multiSelection],
  );

  const handleFocus = useCallback(() => {
    multiSelection.current = false;
  }, [multiSelection]);

  // Register the keyboard handlers via the global event bus.
  useGlobalEvent("keydown", handleKeyDown);
  useGlobalEvent("keyup", handleKeyUp);
  useGlobalEvent("focus", handleFocus);
};
